import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import Common from "../based/Common";
import CommonTable from "../based/CommonTable";
import { INITPAGING, NOTIFY, PLATFORM } from "../based/Constants";
import CheckBox from "../based/inputs/CheckBox";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import StockFolderServices from "../based/services/StockFolderServices";
import AddEditModal from "./AddEditModal";
import SelectImageModal from "./SelectImageModal";

const initPage = {
    pageSize: 10,
    pageNumber: 1,
    orderBy: "id",
    orderDirection: "asc",
    Platform: PLATFORM.Internal,
};

class StockSetModel {
    constructor() {
        this.id = 0;
        this.name = "";
        this.countStock = 0;
        this.isDown = false;
        this.isChecked = false;
    }
}

export default function StockSet(props) {
    const [isBusy, setBusy] = useState(true);
    const [tableGuid, setTableGuid] = useState(Common.generateGuid());
    const tableRef = useRef(null);
    const [datas, setDatas] = useState([new StockSetModel()]);
    const [paging, setPaging] = useState(initPage);
    const [showModal, setShowModal] = useState(false);
    const [msg, setMessage] = useState("");
    const [activeId, setActiveId] = useState(0);
    const [stockImages, setStockImages] = useState([]);
    const [showSelectModal, setShowSelectModal] = useState(false);
    const [pagingStockImage, setPagingStockImage] = useState({ ...INITPAGING });

    useEffect(() => {
        getDatas(paging);
    }, []);

    async function getDatas(newPaging) {
        setBusy(true);
        setMessage("Đang tải dữ liệu...");
        let [err, data] = await StockFolderServices.GetListStockSetPagings(newPaging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(newPaging);
        }
        setBusy(false);
        setMessage(null);
    }

    async function deleteItem(id) {
        setBusy(true);
        let [err, data] = await StockFolderServices.DeleteStockSetById(id);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Xóa thành công");
            getDatas({ ...paging });
            setStockImages([]);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Xóa thất bại");
        }
        setBusy(false);
    }

    async function getStockImage(newPaging) {
        let [err, data] = await StockFolderServices.GetListStockSetImagePagings(newPaging);
        if (!err && data) {
            setStockImages(data.listObjects);
            setPagingStockImage(data.paging);
        } else {
            setStockImages([]);
            setPagingStockImage(newPaging);
        }
    }

    async function addStockImage(payload) {
        let [err, data] = await StockFolderServices.AddStockImageSetConnection(payload);
        if (!err && data) {
            setShowSelectModal(false);
            getStockImage({ ...pagingStockImage, setId: activeId });
        }
    }

    async function removeStockImage(payload) {
        let [err, data] = await StockFolderServices.RemoveStockImageSetConnection(payload);
        if (!err && data) {
            getStockImage({ ...pagingStockImage, setId: activeId });
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Xóa thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Xóa thất bại");
        }
    }

    function _renderAction() {
        return (
            <div className="row flex-row p-10 box__actions">
                <div className="form-group">
                    <button
                        className="btn btn-custom btn-sm m-r-5"
                        onClick={(e) => {
                            setActiveId(0);
                            setShowModal(true);
                        }}
                    >
                        Thêm set
                    </button>
                    <button
                        className={`btn btn-custom btn-sm m-r-5 ${activeId > 0 ? "" : "disabled"}`}
                        onClick={(e) => {
                            setShowModal(true);
                        }}
                    >
                        Sửa set
                    </button>
                    <button
                        className={`btn btn-danger btn-sm m-r-5 ${activeId > 0 ? "" : "disabled"}`}
                        onClick={(e) => {
                            deleteItem(activeId);
                        }}
                    >
                        Xóa
                    </button>
                </div>
            </div>
        );
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className="text-center">
                    <th width={40} className="center"></th>
                    <th className="cursor-pointer">Tên Set</th>
                    <th className="cursor-pointer" width="150">
                        Số họa tiết
                    </th>
                </tr>
            </thead>
        );
    }

    function _renderBody() {
        if (datas && datas.length > 0) {
            return (
                <tbody>
                    {datas.map((item, i) => {
                        return (
                            <React.Fragment key={i}>
                                <tr>
                                    <td>
                                        <CheckBox
                                            checked={item.id == activeId}
                                            name={item.id}
                                            onCheckedChange={(name, value) => {
                                                getStockImage({ ...INITPAGING, pageNumber: 1, pageSize: 200, setId: item.id });

                                                if (item.id == activeId) setActiveId(0);
                                                else setActiveId(item.id);
                                            }}
                                        />
                                    </td>
                                    <td className="d-flex align-items-center">
                                        <span
                                            className="d-flex align-items-center cursor-pointer"
                                            onClick={(e) => {
                                                if (item.id == activeId) setActiveId(0);
                                                else setActiveId(item.id);
                                            }}
                                        >
                                            {item.name}
                                        </span>
                                    </td>
                                    <td>{item.countStock}</td>
                                </tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            );
        }
        return (
            <tbody>
                <tr>
                    <td colSpan={999} className="text-center">
                        Không có dữ liệu!
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <React.Fragment>
            <Breadcrumbs currentPage="Quản lý Set Họa Tiết" />
            <Loading show={isBusy} msg={msg} />
            <Wrapper>
                <div style={{ display: "flex" }}>
                    <div style={{ flexBasis: "40%" }}>
                        <CommonTable
                            data={datas}
                            paging={paging}
                            ref={tableRef}
                            tableGuid={tableGuid}
                            searchBasic
                            hideSearchBasicButton
                            hideSearch
                            renderAction={_renderAction}
                            renderHeader={_renderHeader}
                            renderBody={_renderBody}
                            onFilter={getDatas}
                        />
                    </div>

                    <div className="stock-box">
                        <div className="box-header">
                            <div className="header-left">
                                <div className="form-group">
                                    <label>Họa tiết</label>
                                    <div className="btn-search">
                                        <input type="text" />
                                    </div>
                                </div>
                            </div>
                            <div className="header-right">
                                <button className={`btn btn-custom btn-sm m-r-5 cursor-pointer ${activeId > 0 ? "" : "disabled"}`} onClick={(e) => setShowSelectModal(true)}>
                                    Thêm họa tiết
                                </button>
                            </div>
                        </div>
                        <div className="body-list">
                            {stockImages &&
                                stockImages.map((item, idx) => {
                                    return (
                                        <div className="body-item" key={idx}>
                                            <img src={item.thumbUrl} />
                                            <i
                                                className="fa fa-times remove-icon cursor-pointer"
                                                onClick={(e) => {
                                                    removeStockImage({ setId: activeId, objectId: item.id });
                                                }}
                                            />
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </Wrapper>
            {showModal && (
                <AddEditModal
                    isShowModal={showModal}
                    onClose={(e) => setShowModal(false)}
                    onSave={() => {
                        setShowModal(false);
                        getDatas({ ...paging });
                        setStockImages([]);
                    }}
                    currentId={activeId}
                />
            )}
            {showSelectModal && (
                <SelectImageModal
                    isShowModal={showSelectModal}
                    onClose={(e) => setShowSelectModal(false)}
                    onSave={(ids) => {
                        if (ids && ids.length > 0) {
                            let setId = activeId;
                            let payload = ids.map((item) => ({
                                setId: setId,
                                objectId: item,
                            }));
                            addStockImage(payload);
                            setShowSelectModal(false);
                        }
                    }}
                />
            )}
        </React.Fragment>
    );
}

const Wrapper = styled.div`
    td.add-more {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */
        color: #64c5b1;
    }
    .square {
        height: 20px;
        width: 20px;
        object-fit: contain;
    }

    //stock-box
    .stock-box {
        flex: 1;
        background: #ffffff;
        margin-left: 10px;
    }

    .box-header {
        background: #d9d9d9;
        padding: 10px 10px 0px 10px;
        display: flex;
    }

    .header-left {
        display: flex;
    }

    .header-right {
        margin-left: auto;
    }

    .header-left .form-group {
        display: flex;
        align-items: baseline;
    }

    .header-left .form-group .btn-search {
        margin-left: 10px;
    }

    /* body */
    .body-list {
        display: flex;
        flex-wrap: wrap;
    }

    .body-item {
        height: 100px;
        width: 100px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        margin: 10px;
        padding: 5px;
        position: relative;
    }

    .body-item img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }
    i.fa.fa-times.remove-icon {
        position: absolute;
        right: 10px;
        top: 10px;
    }
`;
